import queryString from "query-string";

import Service from "shared/payment/services";

import {
	openCreditCard as paymentOpenCreditCard,
	setProducts as paymentSetProducts,
} from "ducks/payment";
import { getQuery } from "analytics/util/helpers";

import {
	PRODUCT_TYPES,
	PRODUCT_SUBTYPES,
} from "shared/payment/constants";

// initial state
// ----------------------------------------------------------------------------

export const INITIAL_STATE = {
	isVisible: false,
	selectedProductPackage: {},
	productPackages: [],
	isLoading: true,
	isPurchased: false,
	rateCardName: "",
	discountId: null,
};


// action types
// ----------------------------------------------------------------------------

export const TOGGLE_VISIBLE = "boosts.TOGGLE_VISIBLE";
export const SET_SELECTED_PRODUCT_PACKAGE = "boosts.SET_SELECTED_PRODUCT_PACKAGE";
export const SET_PRODUCT_PACKAGES = "boosts.SET_PRODUCT_PACKAGES";

// reducer
// ----------------------------------------------------------------------------

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case TOGGLE_VISIBLE: {
			return {
				...state,
				isVisible: action.payload,
			};
		}

		case SET_PRODUCT_PACKAGES: {
			return {
				...state,
				productPackages: action.payload.productPackages,
				rateCardName: action.payload.rateCardName,
				discountId: action.payload.discountId,
				isLoading: false,
			};
		}

		case SET_SELECTED_PRODUCT_PACKAGE: {
			return {
				...state,
				selectedProductPackage: action.payload.selectedProductPackage,
			};
		}

		default: {
			return state;
		}
	}
};

// actions
// ----------------------------------------------------------------------------

export const setProductPackages = (productPackages, rateCardName, discountId) => ({
	type: SET_PRODUCT_PACKAGES,
	payload: {
		productPackages,
		rateCardName,
		discountId,
	},
});

export const setSelectedProductPackage = (productPackageId) => (dispatch, getState) => {
	const {
		boosts: {
			productPackages,
		},
	} = getState();

	const selectedProductPackage = productPackages
		.filter(({ productid }) => productid === productPackageId)[0];

	dispatch({
		type: SET_SELECTED_PRODUCT_PACKAGE,
		payload: {
			selectedProductPackage,
		},
	});
};

export const fetchProductPackages = () => (dispatch) => {
	Service.getProductPackages({
		productType: PRODUCT_TYPES.TOKEN,
		productSubtype: PRODUCT_SUBTYPES.BOOST,
	})
		.then(({ productPackages, rateCardName, discountId }) => {
			dispatch(setProductPackages(productPackages, rateCardName, discountId));
			dispatch(setSelectedProductPackage(productPackages[0].productid));
		});
};

export const toggleVisible = (turnOn) => (dispatch) => {
	const noScrollElement = window.document.body;

	if (turnOn && !/noscroll/.test(noScrollElement.className)) {
		noScrollElement.className = `${noScrollElement.className} noscroll`;
	} else {
		noScrollElement.className = noScrollElement.className.replace(/\s*noscroll\s*/, "");
	}

	dispatch({
		type: TOGGLE_VISIBLE,
		payload: turnOn,
	});
};

export const openPayment = () => (dispatch, getState) => {
	const {
		boosts: {
			selectedProductPackage,
			productPackages,
			rateCardName,
		},
	} = getState();

	dispatch(paymentSetProducts(productPackages, rateCardName));
	dispatch(paymentOpenCreditCard(selectedProductPackage));
};

// for mobile web, instead of opening the payment modal, we want to redirect to the payments page
export const openMobilePayment = () => (dispatch, getState) => {
	const {
		boosts: {
			selectedProductPackage,
		},
	} = getState();

	const cameFromQueryParam = getQuery("cf");
	const promoDesignQueryParam = getQuery("pd");

	const qs = {
		productid: selectedProductPackage.productid,
		type: selectedProductPackage.productSubtype,
		pd: promoDesignQueryParam,
		cf: cameFromQueryParam,
	};

	window.location.href = `/payments?${queryString.stringify(qs)}`;
};

export const close = () => (dispatch) => {
	dispatch(toggleVisible(false));
};



// WEBPACK FOOTER //
// ./src/ducks/boosts.js